module.exports = __webpack_public_path__ + "img/1.b4a3dd1f.jpg";